<h3 class="text-center text-light bg-secondary border">Open Offers ({{offerList.length}})</h3>
<div class="row">
    <!--<div class="col">
        <h3>
            Show All:
            <input type="checkbox" style="margin:10px;transform: scale(1.5);"
                   [id]="isShowAll" [name]="isShowAll"
                   [checked]="isShowAll"
                   (change)="toggleShowAll()"
                   autocomplete="off" />
        </h3>
    </div>-->
    <div class="col text-end">
        <button type="button" (click)="refreshOffers()" class="btn btn-success">
            <span class="fas fa-sync" aria-hidden="true"></span> Refresh
        </button>
    </div>
</div>

<kendo-grid #offersGrid
            [data]="gridData"
            [sort]="gridState.sort"
            [filter]="gridState.filter"
            [pageSize]="gridState.take"
            [skip]="gridState.skip"
            [pageable]="true"
            [sortable]="true"
            [filterable]="true"
            [resizable]="false"
            [autoSize]="true"
            class="hideFilterOperators"
            (dataStateChange)="dataStateChange($event)">
    <kendo-grid-column title="Action">
        <ng-template kendoGridCellTemplate let-load>
            <a [routerLink]="" (click)="openOffer(load)">
                <i class="fas fa-angle-double-right fa-lg ml-3"></i>
            </a>
        </ng-template>
    </kendo-grid-column>
    <kendo-grid-column field="quoteOrderID" title="Order #">
        <ng-template kendoGridCellTemplate let-load>
            <span *ngIf="load.quoteOrderID>0">
                <a target="_blank" [routerLink]="['/order-entry', load.quoteOrderID]">{{load.quoteOrderID}}-{{ load.legNumber}}</a>
            </span>
            <span *ngIf="load.quoteOrderID==null||load.quoteOrderID==0">
                {{load.quoteOrderLineID}}
            </span>
        </ng-template>
    </kendo-grid-column>
    <kendo-grid-column field="carrierName" title="Carrier Name">
        <ng-template kendoGridCellTemplate let-load>
            <a target="_blank" [routerLink]="['/carrier-detail', load.carrierCode]">
                {{load.carrierName}}
            </a>
        </ng-template>
    </kendo-grid-column>
    <kendo-grid-column field="carrierCode" title="Carrier 3x3">
        <ng-template kendoGridCellTemplate let-load>
            <a target="_blank" [routerLink]="['/carrier-detail', load.carrierCode]">
                {{load.carrierCode}}
            </a>
        </ng-template>
    </kendo-grid-column>
    <kendo-grid-column field="mcNumber" title="MC #"></kendo-grid-column>
    <kendo-grid-column field="originCity" title="O-City"></kendo-grid-column>
    <kendo-grid-column field="originState" title="O-St"></kendo-grid-column>
    <kendo-grid-column field="destinationCity" title="D-City"></kendo-grid-column>
    <kendo-grid-column field="destinationState" title="D-St"></kendo-grid-column>
    <kendo-grid-column field="offerRatePerMile" title="Per Mile" format="{0:c}"></kendo-grid-column>
    <kendo-grid-column field="offerRate" title="Rate" format="{0:c}"></kendo-grid-column>
    <kendo-grid-column field="createdByEmployeeName" title="Entered By"></kendo-grid-column>
    <kendo-grid-column field="earliestDate" title="Earliest">
        <ng-template kendoGridCellTemplate let-load>
            {{load.earliestDate == '' ? '' : load.earliestDate | date: 'M/dd/yy HH:mm'}}
        </ng-template>
    </kendo-grid-column>
    <kendo-grid-column field="commentText" title="Comment"></kendo-grid-column>
</kendo-grid>
